import React from 'react';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { useRegisterPageContainerError } from '../../../../components/layout/page-container/page-container-error-handler';
import { useRegisterPageRefreshHandler } from '../../../../components/layout/page-container/page-refresh-handler';
import LoadMoreFeedback from '../../../../components/reusable/load-more-feedback/LoadMoreFeedback';
import { useLazyGetAllForAddingExercises } from '../../../../redux/api/exercisesAPI';
import { EXERCISE_FILTERS_PAGE_KEYS } from '../exercise-filters';
import ExerciseList from '../exercise-list/ExerciseList';
import { useExerciseListLazyTab } from '../hooks/useExerciseListLazyTab';
import { useStyles } from './PublishedByUsersExercises.styles';

export default function PublishedByUsersExercises() {
  const {
    exercises,
    isLoading,
    error,
    hasData,
    refetch,
    footerRef,
    handleQueryChange,
    handleRetry,
    isFetching,
    refetchAll,
  } = useExerciseListLazyTab(
    useLazyGetAllForAddingExercises,
    'publishedByUsers',
  );
  const theme = useTheme();

  const { classes } = useStyles(theme);

  useRegisterPageRefreshHandler(refetch);
  useRegisterPageContainerError({
    errors: error ? [error] : [],
    isLoading,
    hasData,
    onRetry: handleRetry,
  });

  return (
    <Box className={classes.exercisesListSearch}>
      <ExerciseList
        exercises={exercises}
        filtersPageKey={EXERCISE_FILTERS_PAGE_KEYS.publishedByUsers}
        afterAddToFavoriteAction={() => {
          refetchAll();
        }}
        isLoading={isLoading}
        disableClientFilter
        onQueryChange={handleQueryChange}
        listFooter={
          <>
            <LoadMoreFeedback
              error={error}
              isFetching={isFetching}
              onRetry={handleRetry}
            />
            <Box ref={footerRef} mb={1} />
          </>
        }
      />
    </Box>
  );
}
